/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const eventContractTranslations = {
  label: "Veranstaltung",
  reasonForDispute: {
    label: "Problem mit Ihrer Veranstaltung",
    question: "Welches Problem gibt es bei der Veranstaltung?",
    options: {
      cancellationRefused: { label: "Widerruf wird nicht akzeptiert" },
      cancelled: { label: "Veranstaltung wurde abgesagt" },
      other: { label: "Anderes Problem" },
    },
  },
  eventType: {
    label: "Art der Veranstaltung",
    question: "Um welche Art von Veranstaltung handelt es sich?",
    helperText:
      'Eine "öffentliche Veranstaltung" ist eine Veranstaltung, für die grundsätzlich jeder Tickets kaufen kann (Parties, Konzerte, Theater, etc.). ' +
      'Eine "Privatveranstaltung" wurde von Ihnen für einen bestimmten Zweck gebucht (Hochzeit, Ihre Geburtstagsparty, etc.).',
    options: {
      private: { label: "Privatveranstaltung" },
      public: { label: "Öffentliche Veranstaltung" },
    },
  },
  contractNumber: {
    label: "Buchungs-/Ticketnummer",
    question: "Wie lautet Ihre Buchungs- oder Ticketnummer?",
    helperText: "Bitte geben Sie hier die Buchungs- oder Ticketnummer Ihrer Veranstaltung an. Sie finden diese meist in der Buchungsbestätigung.",
  },
  eventTitle: {
    label: "Name der Veranstaltung",
    question: "Wie ist der Name der Veranstaltung?",
    helperText: 'Zum Beispiel: "Metallica Hockenheimring" oder "Hochzeitsfeier"',
  },
  eventCity: {
    label: "Stadt der Veranstaltung",
    question: "In welcher Stadt soll die Veranstaltung stattfinden?",
  },
  eventDate: {
    label: "Datum der Veranstaltung",
    question: "Wann soll(te) die Veranstaltung stattfinden?",
  },
  numberOfTickets: {
    question: "Wie viele Tickets haben Sie gekauft?",
    label: "Anzahl der Tickets",
  },
  ...abstractContractClaimTranslations,
};

export default eventContractTranslations;
